import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { getMarkDownText } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { get } from "lodash-es";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchMarkDownText = ({ setIsLoading, setError }: Props) => {
	const {
		state: { assetSearchId },
		actions: { setDataMarkDownText },
	} = useAssetDetailsContext();
	return async () => {
		setIsLoading(true);
		const res = await getMarkDownText(assetSearchId);
		if (res.ok) {
			const markDownTextFromApi = get(
				res,
				"data.tables[0].rows[0].MarkDownText",
				"",
			);
			setDataMarkDownText(markDownTextFromApi);
			setIsLoading(false);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
